module.exports = __webpack_public_path__ + "img/sek-nav.0714adab.png";